import LoginLayout from '../admin/containers/login.layout'

export default function Page() {
  return <LoginLayout />
}
